// Firebase configuration for different environments
// DO NOT COMMIT SENSITIVE KEYS TO VERSION CONTROL IN PRODUCTION APPS

export const firebaseConfigs = {
  production: {
    apiKey: "AIzaSyAIwrvPY3qrbPmPZjSoFVNu3kYe-cw_ZVo",
    authDomain: "sweetspot-prod.firebaseapp.com",
    databaseURL: "https://sweetspot-prod.firebaseio.com",
    projectId: "sweetspot-prod",
    storageBucket: "sweetspot-prod.appspot.com",
    messagingSenderId: "47494266345",
    appId: "1:47494266345:web:efa8feac0eee43883d1f78",
    measurementId: "G-6NGEW8KCXQ"
  },
  qa: {
    apiKey: "AIzaSyCtLhNqq4bfgefLFzX0uTV5GyhpP5P2vtw",
    authDomain: "sweetspot-qa.firebaseapp.com",
    databaseURL: "https://sweetspot-qa.firebaseio.com",
    projectId: "sweetspot-qa",
    storageBucket: "sweetspot-qa.appspot.com",
    messagingSenderId: "601274069060",
    appId: "1:601274069060:web:17a00cceb4efdf55b2cc11",
    measurementId: "G-C3FN26HH49"
  },
  development: {
    // Using QA config for local development
    apiKey: "AIzaSyCtLhNqq4bfgefLFzX0uTV5GyhpP5P2vtw",
    authDomain: "sweetspot-qa.firebaseapp.com",
    databaseURL: "https://sweetspot-qa.firebaseio.com",
    projectId: "sweetspot-qa",
    storageBucket: "sweetspot-qa.appspot.com",
    messagingSenderId: "601274069060",
    appId: "1:601274069060:web:17a00cceb4efdf55b2cc11",
    measurementId: "G-C3FN26HH49"
  }
};

// Get the appropriate config based on environment
export function getFirebaseConfig() {
  const env = process.env.REACT_APP_ENV || 'development';

  if (env === 'production') {
    return firebaseConfigs.production;
  } else if (env === 'qa') {
    return firebaseConfigs.qa;
  } else {
    return firebaseConfigs.development;
  }
}